module.exports = __webpack_public_path__ + "img/active-campaign.fc3bac65.svg";